import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import api from "../lib/api";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [name, setName] = useState("this app");

  useEffect(() => {
    api.get("/settings/public").then((r) => {
      setName(r.data.business_name || "this app");
      if (r.data.app_icon_url) {
        let l = document.querySelector('link[rel="apple-touch-icon"]');
        if (!l) { l = document.createElement("link"); l.rel = "apple-touch-icon"; document.head.appendChild(l); }
        l.href = r.data.app_icon_url;
        let f = document.querySelector('link[rel="icon"]');
        if (!f) { f = document.createElement("link"); f.rel = "icon"; document.head.appendChild(f); }
        f.href = r.data.app_icon_url;
      }
    }).catch(() => {});
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || localStorage.getItem("pwa-dismissed")) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem("pwa-dismissed", "1"); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div data-testid="pwa-install-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:w-96 z-50 nb p-4 bg-white flex items-center gap-3">
      <span className="w-10 h-10 rounded-xl border-2 border-[#171B33] flex items-center justify-center shrink-0" style={{ background: "#A3E635" }}>
        <Download className="w-5 h-5" />
      </span>
      <div className="flex-1 min-w-0">
        <p className="font-display font-extrabold text-sm">Install {name}</p>
        <p className="text-xs text-slate-500">Add to your home screen for a full-screen app experience.</p>
      </div>
      <button data-testid="pwa-install-btn" onClick={install} className="nb-btn nb-btn-lime nb-btn-sm">Install</button>
      <button data-testid="pwa-dismiss-btn" onClick={dismiss} className="text-slate-400 hover:text-slate-700"><X className="w-4 h-4" /></button>
    </div>
  );
}
